export default __webpack_public_path__ + "static/24_34-a2b8493396ef3a9524d56c3590d81af2.png";